module.exports = __webpack_public_path__ + "img/gaziantep-uni-logo.78d51e68.jpg";